import { ArrowDownToLine } from 'lucide-react';

const In = ({ k, l, u, o, set }) => <label><span>{l}</span><span className="lab-iu"><input type="text" inputMode="decimal" data-testid={`vl-${k}`} value={String(o[k]).replace('.', ',')} onChange={(e) => set(k, e.target.value.replace(/[^\d.,-]/g, ''))} /> {u}</span></label>;

// valley lab inputs: two identical tank columns (source / target badge), pipe, hydrants + measuring points, pump
export function ValleyInputs({ x, o, set, onLow }) {
  const p = { o, set }, src = o.dir === 'LR' ? 'L' : 'R';
  const tank = (s) => (
    <div className="vl-col" data-testid={`vl-col-${s}`}>
      <b>{s === 'L' ? x.tankL : x.tankR} <span className={`vl-badge ${src === s ? 'src' : 'tgt'}`} data-testid={`vl-badge-${s}`}>{src === s ? x.srcB : x.tgtB}</span></b>
      {!o.prof && <In k={`z${s}`} l={x.zT} u="m" {...p} />}
      <In k={`lv${s}`} l={x.lvT} u="m" {...p} />
      <In k={`max${s}`} l={x.maxT} u="m" {...p} />
    </div>
  );
  const hyd = (n) => (
    <div className="vl-col" data-testid={`vl-hcol-${n}`}>
      <b>{n === 1 ? x.h1 : x.h2}</b>
      <In k={n === 1 ? 'xHyd' : 'xHyd2'} l={x.pos} u="m" {...p} />
      <In k={`qh${n}`} l={x.qd} u="l/s" {...p} />
    </div>
  );
  return (
    <>
      <div className="vl-cols">{tank('L')}{tank('R')}</div>
      <b className="aq-sub">{x.pipeB}</b>
      <div className="aq-grid">
        {!o.prof && <><In k="zV" l={x.zV} u="m" {...p} /><In k="xv" l={x.xv} u="%" {...p} /><In k="L" l={x.L} u="m" {...p} /></>}
        <In k="d" l={x.d} u="mm" {...p} /><In k="k" l={x.k} u="mm" {...p} /><In k="xLeak" l={x.xLeak} u="m" {...p} />
      </div>
      {o.mode === 'pump' && <div className="aq-grid"><In k="h0" l={x.h0} u="m" {...p} /><In k="h1" l={x.h1p} u="m" {...p} /><In k="q1" l={x.q1} u="l/s" {...p} /></div>}
      <b className="aq-sub">{x.hydB}</b>
      <div className="vl-cols">{hyd(1)}{hyd(2)}</div>
      <label className="vl-check"><input type="checkbox" data-testid="vl-mp3on" checked={!!o.mp3} onChange={(e) => set('mp3', e.target.checked)} /> {x.mp3on}</label>
      {o.mp3 && <div className="vl-mp3"><In k="xM2" l={x.xM2} u="m" {...p} /><button type="button" className="chip" data-testid="vl-m2-low" onClick={onLow}><ArrowDownToLine size={14} /> {x.toLow}</button></div>}
    </>
  );
}
